/* eslint-disable no-await-in-loop */
import _ from 'lodash';
import domains from '../containers/Domains';
import { getToken } from '../services/TokenService';
import { getLocalStorageDataOrFetch } from './fbCallManager';

import contextMakePost from './Context';

const endpoint = domains.fbEndpoint;

export const copyAd = async (data, token) => {
  const parameters = {
    access_token: token,
    adset_id: data.adset_id
  };

  const id = `${data.ad}/copies`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getAd = async (ad, token) => {
  const parameters = {
    access_token: token,
    ad_id: ad,
    fields:
      'id,status,name,creative{object_story_spec, url_tags, effective_object_story_id}, adcreatives{id,name,url_tags}'
  };

  const query = _.template(
    `${endpoint}<%= ad_id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getAdCreative = async (adCreativeId, token) => {
  const parameters = {
    access_token: token,
    id: adCreativeId,
    fields:
      'id,name, object_story_spec, url_tags, effective_object_story_id, product_set_id'
  };

  const query = _.template(
    `${endpoint}<%= id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getFullAd = async (ad, token) => {
  const parameters = {
    access_token: token,
    ad_id: ad,
    fields:
      'account_id,id,name,effective_status,adset{name,start_time,end_time},creative{link_url, object_url, object_story_spec, id, effective_object_story_id},campaign{id,name,start_time,stop_time,objective},adcreatives{url_tags}'
  };

  const query = _.template(
    `${endpoint}<%= ad_id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getAdMetrics = async (ad, token) => {
  const parameters = {
    access_token: token,
    ad_id: ad,
    fields: 'impressions,cpc,ctr,reach,clicks'
  };

  const query = _.template(
    `${endpoint}<%= ad_id%>/insights?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getTargetingSentencelines = async (ad, token) => {
  const parameters = {
    access_token: token,
    ad_id: ad,
    fields: 'targetingsentencelines'
  };

  const query = _.template(
    `${endpoint}<%= ad_id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getEventSourceGroup = async (esg) => {
  const resultToken = await getToken('alexia_user_token');
  const parameters = {
    access_token: resultToken.statusCode !== 500 ? resultToken.token.token : '',
    esg_id: esg.trim(),
    fields: 'id,name'
  };

  const query = _.template(
    `${endpoint}<%= esg_id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const updateMarketingTile = async (data, token) => {
  const parameters = {
    access_token: token,
    creative: {
      object_story_spec: data.creative,
      degrees_of_freedom_spec:{
        creative_features_spec: {
          standard_enhancements: {
            enroll_status: 'OPT_OUT'
          }
        }
      },
      url_tags: data.url_tags
    }
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result;
};

export const updateAdParameters = async (data, token) => {
  const parameters = {
    access_token: token
  };

  if (data.creative) {
    parameters.creative = {
      object_story_spec: data.creative
    };
  }

  if (data.url_tags) {
    parameters.creative.url_tags = data.url_tags;
  }

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result;
};

export const updateStatusAd = async (id, token, status) => {
  const parameters = {
    access_token: token,
    status
  };
  const result = await contextMakePost(parameters, id);
  return result;
};

export const updateAd = async (data, token) => {
  const parameters = {
    access_token: token,
    name: data.name
    // status: 'PAUSED'
  };

  if (data.status) {
    parameters.status = data.status;
  }

  if (data.creative) {
    parameters.creative = data.creative;
  }

  if (data.url_tags) {
    parameters.creative.url_tags = data.url_tags;
  }
  const id = data.id;
  const result = await contextMakePost(parameters, id);

  return result;
};

export const getOnlyAdIds = async (campaignId, token) => {
  const operation = '/ads';
  const parameters = {
    access_token: token,
    campaign_id: campaignId,
    fields: 'id,name'
  };

  const query = _.template(
    `${endpoint}<%= campaign_id%>${operation}?fields=<%= fields%>&access_token=<%= access_token%>&limit=100`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getAds = async (campaignId, token) => {
  let ads = [];
  let jsonResult = {};
  const operation = '/ads';
  const parameters = {
    access_token: token,
    campaign_id: campaignId,
    fields:
      'account_id,id,name,effective_status,adset{name,start_time,end_time,promoted_object},creative{link_url, object_url, object_story_spec, id, effective_object_story_id, thumbnail_url},campaign{id,name,start_time,stop_time,objective},adcreatives{url_tags},ad_review_feedback{global}&limit=30'
  };

  let query = _.template(
    `${endpoint}<%= campaign_id%>${operation}?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  if (jsonResult && jsonResult.data) {
    ads = ads.concat(jsonResult.data);
  }

  while (
    jsonResult &&
    jsonResult.paging &&
    jsonResult.paging.cursors &&
    jsonResult.paging.cursors.after
  ) {
    parameters.fields = `account_id,id,name,effective_status,adset{name,start_time,end_time},creative{link_url, object_url, object_story_spec, id, effective_object_story_id, thumbnail_url},campaign{id,name,start_time,stop_time,objective},adcreatives{url_tags}&limit=30&after=${jsonResult.paging.cursors.after}`;
    query = _.template(
      `${endpoint}<%= campaign_id%>${operation}?fields=<%= fields%>&access_token=<%= access_token%>`
    );

    jsonResult = await getLocalStorageDataOrFetch(query(parameters));

    if (jsonResult && jsonResult.data) {
      ads = ads.concat(jsonResult.data);
    }
  }

  const promise = new Promise((resolve) => {
    resolve({
      data: ads
    });
  });

  return promise;
};

export const createAd = async (accountId, parameters) => {
  const id = `act_${accountId}/ads`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getInstagramStoryIframe = async (adId, token) => {
  const parameters = {
    access_token: token,
    ad_id: adId,
    ad_format: 'INSTAGRAM_STORY'
  };
  const query = _.template(
    `${endpoint}<%= ad_id%>/previews?ad_format=<%= ad_format%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};



// WEBPACK FOOTER //
// ./src/fbApi/Ad.js